import type {
  CallRecordingNoteSummaryResponse,
  PlusCallDirection,
  PlusConversationRecordingResponse,
  PlusRecordingStatus,
} from "@przezmorze/api-types";
import { przezmorzeApi, throwMessageOnStatuses } from "../../../api/api";

export type {
  PlusCallDirection as CallDirection,
  PlusRecordingStatus as CallRecordingStatus,
  PlusConversationRecordingResponse as CallRecordingResponse,
  CallRecordingNoteSummaryResponse as CallRecordingNoteDraft,
};

export async function listCallRecordings(
  numbers: string[],
  dateFrom: string,
  dateTo: string,
  abortSignal?: AbortSignal,
): Promise<PlusConversationRecordingResponse[]> {
  const response = await przezmorzeApi.get<{ items: PlusConversationRecordingResponse[] }>(
    "/plus-conversation-recordings",
    {
      signal: abortSignal,
      params: { numbers: numbers.join(","), dateFrom, dateTo },
    },
  );
  return response.data.items;
}

export async function getCallRecordingFile(recId: string, abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeApi.get<Blob>(`/plus-conversation-recordings/${recId}/file`, {
    signal: abortSignal,
    responseType: "blob",
  });
  return response.data;
}

export async function generateCallRecordingNoteDraft(
  recId: string,
  abortSignal?: AbortSignal,
): Promise<CallRecordingNoteSummaryResponse> {
  try {
    const response = await przezmorzeApi.post<CallRecordingNoteSummaryResponse>(
      `/plus-conversation-recordings/${recId}/note-draft`,
      undefined,
      { signal: abortSignal },
    );
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [404, 501, 503]);
  }
}
